'use client';

import { Link, useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';

import { AgencyManagePanel } from '@/components/platform/AgencyManagePanel';
import { OpenDesk } from '@/components/platform/OpenDesk';
import { usePlatformSummary } from '@/pages/platform/usePlatformSummary';

export function AgencyPage() {
  const slug = useParams().slug ?? '';
  const navigate = useNavigate();
  const { overview, error, reload } = usePlatformSummary('Could not load this agency.');
  const tenant = overview?.tenants.find((row) => row.slug === slug) ?? null;
  const [opening, setOpening] = useState(false);

  return (
    <section className="space-y-4">
      <Link to="/super-admin/agencies" className="text-xs font-semibold text-muted hover:text-ink">All agencies</Link>
      {error && (
        <div className="rounded-2xl border border-danger/40 bg-card px-4 py-6">
          <p className="text-sm text-danger">{error}</p>
          <button type="button" onClick={reload} className="mt-3 rounded-full border border-line px-3 py-1.5 text-xs font-semibold text-ink">Try again</button>
        </div>
      )}
      {overview === null && !error && <div className="h-40 animate-pulse rounded-2xl bg-card" aria-hidden="true" />}
      {overview && !tenant && <p className="rounded-2xl border border-line bg-card px-6 py-10 text-center text-sm text-muted">This agency is not registered.</p>}
      {tenant && (
        <div className="rounded-2xl border border-line bg-card px-5 py-4">
          <h2 className="text-lg font-semibold text-ink">{tenant.name}</h2>
          <div className="mt-4">
            <AgencyManagePanel tenant={tenant} onChanged={reload} onEnterDesk={() => setOpening(true)} />
          </div>
        </div>
      )}
      {tenant && (
        <OpenDesk open={opening} agencyName={tenant.name} slug={tenant.slug} onClose={() => setOpening(false)} onStarted={() => navigate('/admin')} />
      )}
    </section>
  );
}
